module.exports = __webpack_public_path__ + "static/media/9DESA5.0f48305e.jpg";